// const days_seconds = 60 * 60 * 24;
import { api } from '@/modules/apiv2';

export default {
  state: {
    config: null,
  },

  getters: {
    config(state) {
      return state.config;
    },
  },

  mutations: {
    setConfig(state, config) {
      state.config = config;
    },
  },

  actions: {
    async getConfig({ commit, getters }) {
      if (!getters.currentUserIsAdmin) {
        // Current user is not an admin, so we cannot fetch config
        return;
      }
      if (!(getters.currentUserIsOwner || getters.currentUserIsConsumer)) {
        console.warn('getConfig() -- currentUser is not a consumer/owner');
        return;
      }
      const endpoint = getters.configEndpoint;

      let data = await api.get(endpoint);
      commit('setConfig', data);
    },

    updateConfig({ commit, getters }, data) {
      if (!(getters.currentUserIsOwner || getters.currentUserIsConsumer)) {
        console.warn('updateConfig() -- currentUser is not a consumer/owner');
        return;
      }

      const endpoint = getters.configEndpoint;

      return api
        .put(endpoint, data)
        .then((data) => {
          commit('setConfig', data);
          return data;
        })
        .catch((error) => {
          throw error;
        });
    },
  },
};
